
import openInNewTab from './openInNewTab';

const openPolicyPaymentUrl = (policyNumber: string) => {
  return openInNewTab(`https://pay.alpha.ge/pay/init/policy/${policyNumber}`);
}

export default openPolicyPaymentUrl;
